<form style="width: 400px; min-width: 50%">
  <h1 mat-dialog-title>
    @if (this.data.type !== 'flag' && data.type !== 'user') {
      <span>
      </span>
    }
    @if (data.type === 'user') {
      <span>
        {{'MarketMonitor.monitor.contact.header' | translate}}
      </span>
    }
    @if (this.data.type === 'flag') {
      <span>
        {{'MarketMonitor.monitor.flagged.header' | translate}}
      </span>
    }
  </h1>
  <div mat-dialog-content>
    @if (this.data.type !== 'flag' && data.type !== 'user') {
      <div>
        Something went wrong. Please try again.
      </div>
    }
    @if (data.type === 'user') {
      <div class="row">
        <div class="col-4">
          <div class="col-12">
            <mat-label><b>{{'MarketMonitor.monitor.contact.lblName' | translate}}</b></mat-label>
          </div>
          <div class="col-12">
            <mat-label><b>{{'MarketMonitor.monitor.contact.lblOrganisation' | translate}}</b></mat-label>
          </div>
          @if (user.email) {
            <div class="col-12">
              <mat-label><b>{{'MarketMonitor.monitor.contact.lblEmail' | translate}}</b></mat-label>
            </div>
          }
          @if (user.phone) {
            <div class="col-12">
              <mat-label><b>{{'MarketMonitor.monitor.contact.lblPhone' | translate}}</b></mat-label>
            </div>
          }
          @if (user.mobile) {
            <div class="col-12">
              <mat-label><b>{{'MarketMonitor.monitor.contact.lblMobile' | translate}}</b></mat-label>
            </div>
          }
        </div>
        <div class="col-8">
          <div class="col-12">
            {{user.firstName}} {{user.lastName}}
          </div>
          <div class="col-12">
            {{user.organisationName}}
          </div>
          @if (user.email) {
            <div class="col-12">
              {{user.email}}
            </div>
          }
          @if (user.phone) {
            <div class="col-12">
              {{user.phone}}
            </div>
          }
          @if (user.mobile) {
            <div class="col-12">
              {{user.mobile}}
            </div>
          }
        </div>
      </div>
    }
    @if (this.data.type === 'flag') {
      <div [innerHTML]="flaggedDetails">
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="secondary" [mat-dialog-close]>{{'btnClose' | translate}}</button>
  </div>
</form>